export enum ManufacturerOPEEnum {
  GetManufacturers = 'getManufacturers',
  DelManufacturer = 'delManufacturer'
}
